<script>
</script>

<div class="divider"></div>

<div id="bio" class="section flow-text">
  <!-- <h3 class="blue-grey-text text-lighten-2">Short bio</h3> -->
  <p>
    I’m a self-taught <strong>visual artist</strong>, with additional expertise
    as a <strong>full-stack developer</strong> and more recently, a
    <strong>data scientist</strong>. Born and raised in Guadalajara, Mexico,
    I’ve been living abroad for over two decades.
  </p>
  <p>
    What began as a childhood hobby took a professional turn in the late ’90s
    when I was commissioned to create illustrations for an American editorial
    publication based in Las Vegas, NV. After graduating high school, I decided
    to pursue formal training and enrolled at the <strong
      ><a
        title="University of Guadalajara"
        href="https://www.cuaad.udg.mx/"
        target="_blank"
        rel="noreferrer"
        aria-label="University of Guadalajara">University of Guadalajara</a
      ></strong
    >
    to study Visual Arts for Plastic Expression (<em
      >painting, printmaking, sculpture and photography</em
    >).
  </p>
</div>

<style>
  .divider {
    background-color: #90a4ae78;
  }
  .section {
    background-color: transparent !important;
  }

  @media screen and (min-width: 400px) {
    .flow-text {
      font-size: 1.2em;
    }
  }
</style>
